exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports
exports.i(require("-!../../../../node_modules/css-loader/index.js!vue-directive-tooltip/css/index.css"), "");

// module
exports.push([module.id, ".product-ship-options[data-v-0c96c324] {\n  padding: 1em 0;\n  width: 100%;\n}\n.product-ship-options .radio-label[data-v-0c96c324] {\n  padding-bottom: 1em;\n}\n.product-ship-options .radio-label .mr-radio[data-v-0c96c324] {\n  margin-top: 0.15em;\n}\n", ""]);

// exports
